// extracted by mini-css-extract-plugin
export default {"title":"A9C9tlttirxa16juxHHX","cta":"cVlmZu02XT1SkAIiI4cO"};